import type { ClientConstants } from '@/constants/ClientConstants';

/** Build-time profile for `VITE_CLIENT`. Loaded via `getClientConfigForEnv`. */
export type ClientProfile = {
  id: ClientConstants;
  legalPages: { termsSegment: string; privacySegment: string };
  footer: { useCustomPdfFooter: boolean };
};

const STANDARD_LEGAL_PAGES = { termsSegment: 'terms', privacySegment: 'privacy' };

export function standardClientProfile(clientId: ClientConstants): ClientProfile {
  return {
    id: clientId,
    legalPages: STANDARD_LEGAL_PAGES,
    footer: { useCustomPdfFooter: false },
  };
}
